import React from 'react';
import Background from '../../images/Background.png'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import axios from 'axios';
import { withRouter } from 'react-router'
import { Progress } from 'antd';
import { translate } from 'react-i18next';
import { fbFunctionsURL } from '../../config.js'


class CreateUser extends React.Component {

  state = { error: false }

  componentDidMount() {
    const _this = this
    let hash = this.props.location.search
    hash = hash.substr(4)

    const url = `${fbFunctionsURL}/findUserIdByHash`
    axios.post(url, {
      hash: hash
    })
      .then(function (response) {
        console.log('response', response);
        if (response.data.userId !== 'none') {
          console.log('UID:', response.data.userId);
          const url2 = `${fbFunctionsURL}/createToken`
          axios.post(url2, {
            uid: response.data.userId
          })
            .then(function (response) {
              let customToken = response.data.customToken
              _this.props.firebase.auth().signInWithCustomToken(customToken)
                .then(function () {
                  _this.props.history.push('/')
                })
                .catch(function (error) {
                  _this.setState({ error: true })
                });
            })
        } else {
          _this.props.history.push('/')
        }
      }).catch(error => console.log(error))
  }

  render() {
    const { t } = this.props;
    return (
      <div style={styles.background}>
        <div style={{ width: 'max-content', margin: '0 auto' }}>
          {this.state.error ?
            <div>
              <h1 style={{ marginTop: 50, color: 'red' }}>{t('An error happened while signing you in.')}</h1>
            </div>
            :
            <div>
              <h1 style={{ marginTop: 50, color: 'white' }}>{t('Welcome to Tracker Apps!')}</h1>
              <h3 style={{ color: 'white' }}>{t('Please wait while you account is being verified...')}</h3>
            </div>
          }
        </div>
      </div>
    )
  }
}

const styles = {
  background: {
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100vh',
    width: '100vw',
    position: 'absolute'
  }
}


const enhancer = compose(
  translate('lang'),
  firebaseConnect((props, store) => { })
)
export default withRouter(enhancer(CreateUser))



// WEBPACK FOOTER //
// ./src/containers/CreateUser/index.jsx